export const WinModal = ({ show, onClose, children }) => {
    if (!show) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <section className="modal-main" onClick={(e) => e.stopPropagation()}>
                {children}
            </section>
        </div>
    );
};
